import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import Plugin, { PluginProps } from '../Plugin';

const TeacherGuide = (props: PluginProps) => {
  const { content, isTeacherGuideDisplayed } = props;
  if (!isTeacherGuideDisplayed) {
    return null;
  }
  return (
    <Box background="gray.100" padding={2} marginBottom={10}>
      {content.children.map((child, index) => {
        return <Plugin key={index} {...props} content={child} />;
      })}
    </Box>
  );
};

export default TeacherGuide;
